<template>
  <div class="item" :class="this.type!=='cancel'? 'cell_dark':'cell_light'">
    <div class="line border">
      <div class="title dark">配送时间:</div>
      <div class="value dark">{{info.deliveryTimeString || info.deliveryTime}}</div>
    </div>
    <div class="line">
      <div class="title dark">生日员工:</div>
      <div class="value lightDark">{{info.personNames}}</div>
    </div>
    <div class="line">
      <div class="title dark">已选蛋糕:</div>
      <div class="value lightDark">{{info.cakeName}}</div>
    </div>
    <div class="line">
      <div class="title dark">联 系 人 :</div>
      <div class="value lightDark">{{info.contactsName}}</div>
    </div>
    <div class="line">
      <div class="title dark">联系电话:</div>
      <div class="value lightDark">{{info.contactsPhone}}</div>
    </div>
    <div class="line">
      <div class="title dark">配送地址:</div>
      <div class="value lightDark">{{info.contactsAddress}}</div>

      <Button
        v-if="info.cancelShow && this.type!=='cancel'"
        class="cancel_butt"
        size="small"
        type="default"
        @click="cancelAction"
      >取消订单</Button>
    </div>
  </div>
</template>

<script>
// import { formatShortDate } from '@/utils/date.js'
import { Button, Dialog } from 'vant';
import { cancelCakeOrder } from '@/api/birthday';

export default {

  props: ['info', 'type'],

  components: {
    Button,
  },

  // filters: {
  //   formatShortDate,
  // },

  methods: {
    cancelAction() {
      Dialog.confirm({
        title: '是否确认取消订单',
      }).then(() => {
        const params = {
          orderId: this.info.orderId,
        };
        cancelCakeOrder(params).then(res => {
          this.$router.replace('/birthday/cake')
        }).catch(({ message = '系统异常' }) => {
          this.$toast(message);
        })
      });
    }
  },

}
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.cell_dark {
  color: #333;
}

.cell_light {
  color: #999;
}

.item {
  .line {
    display: flex;
    justify-content: flex-start;
    .title {
      width: 140px;
    }
    .value {
      width: calc(100% - 140px);
    }
    .dark {
      font-weight: bold;
    }
    .lightDark {
      color: #666;
    }
    .cancel_butt {
      position: absolute;
      right: 60px;
      color: #ef4c4f;
      background-color: inherit;
      border: inherit;
      font-weight: bold;
    }
  }
  .border {
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #f0f0f0;
  }
}
</style>